import { useQuery } from "@tanstack/react-query";
import { apiGet } from "../../lib/api";
import type { FaturasPendentesResponse } from "./types";

export type TipoPendente = "fornecedor" | "cliente";

export const faturasPendentesKey = (empresa?: string, tipo?: TipoPendente) =>
  ["faturas-pendentes", empresa ?? "", tipo ?? ""] as const;

// Faturas pendentes de reconciliação — só filtradas por empresa (sem período,
// mostra tudo o que está por resolver), com o intervalo de datas para dar
// contexto de "desde quando" há pendências.
export function useFaturasPendentes(empresa?: string, tipo: TipoPendente = "fornecedor") {
  return useQuery<FaturasPendentesResponse>({
    queryKey: faturasPendentesKey(empresa, tipo),
    queryFn: () =>
      apiGet<FaturasPendentesResponse>(
        `/api/conciliacao/faturas-pendentes?empresa=${empresa}&tipo=${tipo}`
      ),
    enabled: !!empresa,
  });
}
